import { useState, memo } from "react";
import { useLocation } from "react-router-dom";
import { Header, Title, AvatarImage, ToggleMenu, Toggle, Subtitle, HeaderRight, NotificationBellButton, MobileBadge } from "./styles";
import StickyActions from "../StickyActions";
import StickyMenu from "../StickyMenu";
import SidebarMenu from "../SidebarMenu";
import { connect } from "react-redux";
import { User } from "../../../../types";
import Grid from "../../../../components/Grid";
import UserRoundedIcon from "../../../../assets/icons/user-rounded.svg";
import { Preference } from "../../../../types/preferences";
import { useLayout } from "../../../../providers/LayoutProvider";
import arrowBackIcon from "../../../../assets/icons/arrow-backward.svg";
import Icon from "../../../Icon";
import GoBack from "../../../GoBack";
import hamburger from "../../../../assets/hamburger.svg";
import notificationIcon from "../../../../assets/sessions/notification-icon.svg";
import NotificationPanel from "../../../NotificationPanel";


interface ComponentProps {
  userInformation: User;
  userInformationStates;
  preferences: Preference[];
  preferencesStates: {
    loading: boolean;
    error: string | boolean;
    success: boolean;
  };
  subscriptions;
  subscriptionsStates;
  navigationLevel?: number;
  unreadCount: number;
}

const Component = ({
  userInformation,
  userInformationStates,
  preferences,
  preferencesStates,
  subscriptions,
  subscriptionsStates,
  navigationLevel,
  unreadCount,
}: ComponentProps) => {
  const location = useLocation();
  const { layout } = useLayout();
  const [menuIsOpened, setMenuIsOpened] = useState(false);
  const [notificationPanelOpen, setNotificationPanelOpen] = useState(false);

  return (
    <>
      <Grid.Container>
        <Grid.Row>
          <Grid.Col>
            <Header>
              {layout?.page?.back && (
                <GoBack backTo={layout?.page?.back} showAlt></GoBack>
              )}
              <Title>{layout?.page?.title}</Title>
              <HeaderRight>
                <NotificationBellButton onClick={() => setNotificationPanelOpen(true)}>
                  <Icon icon={notificationIcon} size="22px" color="rgba(45, 52, 54, 0.75)" />
                  {unreadCount > 0 && (
                    <MobileBadge>{unreadCount > 99 ? "99+" : unreadCount}</MobileBadge>
                  )}
                </NotificationBellButton>

                <ToggleMenu onClick={() => setMenuIsOpened(true)}>
                  <Toggle skin={layout.skin}>
                    <img src={hamburger} alt="hamburger" width="24px" height="24px" />
                  </Toggle>
                </ToggleMenu>
              </HeaderRight>
            </Header>

            {layout?.page?.subtitle && (
              <Subtitle>{layout?.page?.subtitle}</Subtitle>
            )}
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>

      <SidebarMenu
        menuIsOpened={menuIsOpened}
        setMenuIsOpened={setMenuIsOpened}
      />

      <NotificationPanel
        isOpen={notificationPanelOpen}
        onClose={() => setNotificationPanelOpen(false)}
      />

      {navigationLevel === 1 && <StickyMenu useLocation={useLocation} />}
      {navigationLevel === 2 && <StickyActions useLocation={useLocation} />}
    </>
  );
};

const state = ({ userStore, preferencesStore, inAppNotificationStore }) => {
  const { data: userInformation, states: userInformationStates } =
    userStore.information;
  const { data: preferences, states: preferencesStates } =
    preferencesStore.preferences;
  const { data: subscriptions, states: subscriptionsStates } =
    userStore.subscriptions;
  const { data: unreadCount } = inAppNotificationStore.unreadCount;

  return {
    userInformation,
    userInformationStates,
    preferences,
    preferencesStates,
    subscriptions,
    subscriptionsStates,
    unreadCount,
  };
};

const MemoizedComponent = memo(Component);
export default connect(state)(MemoizedComponent);
